/* Keyboard companion for the existing Lexington samples dialog. The original
   delegated click handler owns selection, totals and ordering. This file never
   calls a purchase action or changes sample IDs, quantities or prices. */
(function () {
  'use strict';
  function init() {
    var overlay = document.getElementById('efLhsOverlay');
    var dialog = overlay && overlay.querySelector('[role="dialog"]');
    var grid = dialog && dialog.querySelector('#efLhsGrid');
    if (!dialog || !grid || overlay.dataset.efLabFocusBound) return;
    overlay.dataset.efLabFocusBound = '1';

    // The original tiles are labels without inputs. A real checkbox makes each
    // label keyboard operable, using the same click that the native grid handles.
    // Native preventDefault cancels checkbox activation, so observe its final
    // is-on class and synchronize checked after that event has finished.
    var choices = [];
    grid.querySelectorAll('label.ef-lhs-tile[data-vid][data-name]').forEach(function (tile) {
      if (tile.querySelector('input')) return;
      var input = document.createElement('input');
      input.type = 'checkbox';
      input.className = 'ef-lab-sample-choice';
      input.setAttribute('aria-label', tile.getAttribute('data-name') + ' color sample');
      input.style.cssText = 'flex:0 0 auto;width:20px;height:20px;margin:0 0 0 auto;accent-color:#121212;';
      input.checked = tile.classList.contains('is-on');
      tile.appendChild(input);
      var decoration = tile.querySelector('.ef-lhs-check');
      if (decoration) decoration.style.display = 'none';
      choices.push({ tile: tile, input: input });
    });
    var syncPending = false;
    new MutationObserver(function () {
      if (syncPending) return;
      syncPending = true;
      // A browser may deliver the mutation callback before rolling back the
      // canceled native checkbox activation. The next task reads settled state.
      setTimeout(function () {
        syncPending = false;
        choices.forEach(function (choice) { choice.input.checked = choice.tile.classList.contains('is-on'); });
      }, 0);
    }).observe(grid, { attributes: true, attributeFilter: ['class'], subtree: true });

    var wasOpen = false;
    var opener = null;
    function isOpen() { return overlay.classList.contains('is-open') && overlay.getAttribute('aria-hidden') === 'false'; }
    function controls() {
      return Array.prototype.filter.call(dialog.querySelectorAll('a[href],button,input,select,textarea,[tabindex]'), function (el) {
        return !el.disabled && el.tabIndex >= 0 && el.getClientRects().length && !el.closest('[hidden],[inert]');
      });
    }
    function focusFirst() {
      var first = controls()[0];
      if (first) first.focus();
    }
    function sync() {
      var open = isOpen();
      if (open && !wasOpen) {
        opener = document.activeElement;
        if (!opener || opener === document.body || overlay.contains(opener)) opener = document.querySelector('[data-lh-samples-open]');
        wasOpen = true;
        focusFirst();
      } else if (!open && wasOpen) {
        wasOpen = false;
        if (opener && opener.isConnected) opener.focus();
        opener = null;
      }
    }
    document.addEventListener('keydown', function (event) {
      if (!isOpen() || event.key !== 'Tab') return;
      var items = controls();
      if (!items.length) return;
      var index = items.indexOf(document.activeElement);
      if (index === -1 || (!event.shiftKey && index === items.length - 1) || (event.shiftKey && index === 0)) {
        event.preventDefault();
        items[event.shiftKey ? items.length - 1 : 0].focus();
      }
    }, true);
    document.addEventListener('focusin', function (event) {
      if (isOpen() && !dialog.contains(event.target)) focusFirst();
    });
    new MutationObserver(sync).observe(overlay, { attributes: true, attributeFilter: ['class', 'aria-hidden'] });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
}());
